import { Form } from 'formik'
import styled, { css } from 'styled-components'

import theme from 'theme_'
import CommonButton from 'components/Button/CommonButton'
import { Font14, H1, H5 } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'
import { ButtonPaddings } from 'components/Button/styles'

export const StyledLicensesContainer = styled.div`
  padding: 12px;
  @media ${theme.devices.tablet} {
    padding: 0 40px 16px 40px;
  }
`

export const LicensesSearchWrapper = styled.div`
  margin-bottom: ${theme.spacing.s};
  display: flex;
  gap: ${theme.spacing.xs};
  flex-direction: column;

  @media ${theme.devices.tablet} {
    flex-direction: row;
    gap: ${theme.spacing.md};
    margin-bottom: ${theme.spacing.base};
  }
`

export const LicensesFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xxxl};
  background: ${theme.colors.white};
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  border-radius: 8px;
`

export const LicensesFilterItem = styled.div`
  display: flex;
  align-items: center;
`
export const LicensesFilterItemTitle = styled.div`
  ${Font14}
  margin-left: ${theme.spacing.base};
  color: ${theme.colors.otterWarmBlack};
  line-height: 24px;
  font-weight: 300;
`

export const StyledLicensesHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  flex-wrap: wrap;
  gap: ${theme.spacing.xs};
`

export const VisitStoreButton = styled(CommonButton)`
  && {
    appearance: none;
  }
  font-weight: 900;
  background: transparent;
  order: 2;
  padding: ${ButtonPaddings.small};

  @media ${theme.devices.tabletLandscape} {
    order: unset;
    padding: ${ButtonPaddings.DEFAULT};
  }
`

export const LicensesHeaderTitle = styled(H1)<{ $hasExtraBtn?: boolean }>`
  order: 0;
  margin-right: ${theme.spacing.s};
  margin-bottom: ${theme.spacing.s};
  ${(p) =>
    p.$hasExtraBtn &&
    css`
      flex-basis: 100%;
    `}

  @media ${theme.devices.tablet} {
    flex-basis: unset;
    order: unset;
    margin-bottom: 0;
  }
`

export const RightBlock = styled.div`
  display: flex;
  flex-direction: row;
`

export const StyledNoLicenses = styled(H5)`
  text-align: center;
  color: ${theme.colors.disabledGrey};
`

export const LicensesToggleButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  order: 3;
  flex: 1;
  flex-basis: 100%;

  @media ${theme.devices.tabletLandscape} {
    margin: 0 8px;
    order: unset;
    flex-basis: auto;
  }
`

export const LicensesToggleButton = styled(CommonLinkButton)<{
  isActive: boolean
}>`
  padding: 8px 0;
  ${Font14};
  border: 1px solid ${theme.colors.pelicanGrey};
  min-width: 160px;
  color: ${theme.colors.duneWarmGrey};
  width: 100%;
  ${(p) =>
    p.isActive &&
    `
      border: 1px solid ${theme.colors.horizonOrange};
      color: ${theme.colors.horizonOrange};
    `}

  @media ${theme.devices.tabletLandscape} {
    width: unset;
  }

  :hover {
    opacity: 0.8;
  }

  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:last-child {
    border-radius: 0 8px 8px 0;
  }
`

export const ImportLicenseButton = styled(CommonButton)`
  margin-right: ${theme.spacing.base};
  background: transparent;
  order: 1;
  padding: ${ButtonPaddings.small};

  @media ${theme.devices.tablet} {
    order: unset;
    margin-left: auto;
  }

  @media ${theme.devices.tabletLandscape} {
    padding: ${ButtonPaddings.DEFAULT};
  }
`

export const ImportLicenseForm = styled(Form)`
  max-width: 320px;
  margin: 0 auto;
`
